export default __webpack_public_path__ + "static/media/picto_cocktail.c89c6b7f.png";